module.exports = "<div class=\"chart\">\n  <div [chart]=\"chartService.icuCharts.is.rr.chart\"></div>\n</div>"